/*
 * Summer vibes variant gallery — Impulse / Flickity 2.3 integration.
 *
 * Keep the selected variant's image, followed by unassigned supporting media.
 * Excluded slides are held outside Flickity's viewport, not left as hidden cells.
 * The existing Impulse slideshow and its listeners stay in place. Slide indexes,
 * cached thumbnail links and pagination all describe the same visible list.
 */
(function () {
  'use strict';

  // product-images.liquid can include this asset more than once (quick shop).
  if (window.__svVariantGalleryCellsV2) return;
  window.__svVariantGalleryCellsV2 = true;

  var SCOPE = '[data-section-type="product"]';
  var SLIDE = '.product-main-slide[data-media-id]';
  var controllers = [];
  var pending = new WeakMap();

  function parseVariants(scope) {
    var el = scope.querySelector('[data-variant-json]');
    if (!el) return [];
    try {
      var variants = JSON.parse(el.textContent || '[]');
      return Array.isArray(variants) ? variants : [];
    } catch (error) {
      return [];
    }
  }

  function productInstance(scope) {
    var instances = window.theme && window.theme.sections &&
      window.theme.sections.instances;
    if (!instances) return null;
    for (var i = 0; i < instances.length; i++) {
      if (instances[i].container === scope && instances[i].type === 'product') {
        return instances[i];
      }
    }
    return null;
  }

  function findController(scope) {
    for (var i = 0; i < controllers.length; i++) {
      if (controllers[i].scope === scope) return controllers[i];
    }
    return null;
  }

  function selectedVariant(state) {
    var field = state.scope.querySelector('select[name="id"], input[name="id"]');
    if (field && state.variantsById[String(field.value)]) {
      return state.variantsById[String(field.value)];
    }
    var current = state.product.variants && state.product.variants.currentVariant;
    if (current && state.variantsById[String(current.id)]) return current;
    return state.variants[0];
  }

  function slideId(slide) {
    return String(slide.getAttribute('data-media-id') || '');
  }

  function refreshAos() {
    if (window.AOS && typeof window.AOS.refreshHard === 'function') {
      window.AOS.refreshHard();
    }
  }

  function selectMedia(state, mediaId) {
    var flkty = state.product.flickity.slideshow;
    var target = state.visible.find(function (record) {
      return record.id === mediaId;
    });
    if (target) flkty.selectCell(target.slide, false, true);
  }

  function apply(state, variant) {
    var wrapper = state.product.flickity;
    var flkty = wrapper && wrapper.slideshow;
    // Do not hide anything unless the actual theme slideshow is available.
    if (!flkty || !flkty.isActive || !flkty.slider) return;

    var variantId = variant ? String(variant.id) : '';
    var keepId = variant && variant.featured_media ?
      String(variant.featured_media.id || '') : '';
    if (!state.records.some(function (record) { return record.id === keepId; })) {
      keepId = ''; // A missing/unassigned variant image leaves the full gallery.
    }

    var visible = state.records.filter(function (record) {
      return !keepId || record.id === keepId || !state.assigned[record.id];
    });
    if (!visible.length) return;
    // Use one order for the carousel, thumbnails and current indexes.
    if (keepId) {
      visible.sort(function (a, b) {
        if (a.id === keepId) return -1;
        if (b.id === keepId) return 1;
        return a.originalIndex - b.originalIndex;
      });
    }
    var signature = visible.map(function (record) { return record.id; }).join(',');
    if (signature === state.signature && flkty === state.flkty) {
      if (variantId !== state.variantId) selectMedia(state, keepId);
      state.variantId = variantId;
      return;
    }

    var previousSlide = flkty.selectedElement;
    if (previousSlide && typeof state.product.stopMediaOnSlide === 'function') {
      state.product.stopMediaOnSlide(previousSlide);
    }

    var visibleIds = {};
    visible.forEach(function (record, index) { visibleIds[record.id] = index; });
    state.records.forEach(function (record) {
      var show = Object.prototype.hasOwnProperty.call(visibleIds, record.id);
      var index = show ? String(visibleIds[record.id]) : 'sv-hidden-' + record.id;
      record.slide.setAttribute('data-index', index);
      record.slide.setAttribute('tabindex', '-1');
      record.slide.classList.remove('is-selected');
      record.slide.setAttribute('aria-hidden', 'true');
      // Remove old inline filtering. The holding container hides excluded media.
      record.slide.style.display = '';
      if (!show) state.holding.appendChild(record.slide);
      if (record.thumb) {
        record.thumb.setAttribute('data-index', index);
        record.thumb.classList.toggle('hide', !show);
        record.thumb.style.display = show ? '' : 'none';
      }
      if (record.link) {
        record.link.setAttribute('data-index', index);
        record.link.classList.remove('is-active');
      }
    });

    visible.forEach(function (record) {
      flkty.slider.appendChild(record.slide);
      if (record.thumb && record.thumbParent) {
        record.thumbParent.appendChild(record.thumb);
      }
    });

    // The original listeners read media IDs at click/focus time; retain them.
    wrapper.childNavEls = visible.map(function (record) { return record.thumb; });
    wrapper.childNavLinks = visible.map(function (record) { return record.link; });
    state.visible = visible;
    state.signature = signature;
    state.variantId = variantId;
    state.flkty = flkty;

    // Reset indexes before any native callback can read the remapped DOM.
    state.product.settings.currentSlideIndex = 0;
    flkty.selectedIndex = 0;
    flkty.reloadCells();
    // Flickity uses cellChange to rebuild page dots and update draggability.
    flkty.emitEvent('cellChange', [0]);
    flkty.selectCell(visible[0].slide, false, true);
    wrapper.currentSlide = visible[0].slide;
    // select(0) need not emit change when the previous index was also zero.
    // Explicitly synchronize native thumbnail, focus, media and arrow state.
    wrapper.slideChange(0);
    flkty.resize();
    refreshAos();
  }

  function createController(scope, product, variants) {
    var wrapper = product.flickity;
    var flkty = wrapper && wrapper.slideshow;
    if (!flkty || !flkty.isActive || !flkty.slider) return null;
    // Native Impulse image sets already manage their own cell membership.
    if (product.settings.imageSetName || flkty.options.cellSelector) return null;

    var state = {
      scope: scope,
      product: product,
      variants: variants,
      variantsById: {},
      assigned: {},
      records: [],
      visible: [],
      signature: '',
      variantId: '',
      flkty: null,
      changeTimer: null
    };
    variants.forEach(function (variant) {
      state.variantsById[String(variant.id)] = variant;
      if (variant.featured_media && variant.featured_media.id) {
        state.assigned[String(variant.featured_media.id)] = true;
      }
    });
    if (!Object.keys(state.assigned).length) return null;

    var slides = Array.prototype.slice.call(flkty.slider.querySelectorAll(SLIDE));
    var thumbLinks = Array.prototype.slice.call(scope.querySelectorAll('.product__thumb[data-id]'));
    state.records = slides.map(function (slide, index) {
      var id = slideId(slide);
      var link = thumbLinks.find(function (item) {
        return String(item.getAttribute('data-id')) === id;
      });
      var thumb = link && link.closest('.product__thumb-item');
      return {
        id: id,
        slide: slide,
        originalIndex: index,
        link: link,
        thumb: thumb,
        thumbParent: thumb && thumb.parentNode
      };
    });
    // This Impulse integration requires its matching thumbnail for every cell.
    // Unsupported markup stays native rather than becoming partially filtered.
    if (!state.records.length || state.records.some(function (record) {
      return !record.link || !record.thumb;
    })) return null;

    state.holding = document.createElement('div');
    state.holding.setAttribute('data-sv-variant-gallery-holding', '');
    state.holding.setAttribute('aria-hidden', 'true');
    state.holding.hidden = true;
    state.holding.style.display = 'none';
    // Keep it outside the main slider: a native Flickity re-init must never
    // mistake this holding div for another slide or include it in PhotoSwipe.
    scope.appendChild(state.holding);

    state.onVariant = function (event) {
      if (!event.detail || !Object.prototype.hasOwnProperty.call(event.detail, 'variant')) return;
      var variant = event.detail.variant;
      if (variant && !state.variantsById[String(variant.id)]) return;
      apply(state, variant);
    };
    // Capture runs before Impulse's native image-selection listener on this
    // same product, so its data-index lookup already refers to the new list.
    scope.addEventListener('variantChange', state.onVariant, true);
    scope.addEventListener('variantImageChange', state.onVariant, true);
    state.onChange = function (event) {
      var target = event.target;
      if (!target || !(target.name === 'id' || target.hasAttribute('data-variant-input') ||
          target.closest('.variant-input-wrap'))) return;
      window.clearTimeout(state.changeTimer);
      state.changeTimer = window.setTimeout(function () {
        if (scope.isConnected) apply(state, selectedVariant(state));
      }, 60);
    };
    scope.addEventListener('change', state.onChange);
    scope.dataset.svGalleryBound = 'true';
    apply(state, selectedVariant(state));
    return state;
  }

  function init(scope, attempt) {
    if (!scope.isConnected || findController(scope)) return;
    var product = productInstance(scope);
    var variants = parseVariants(scope);
    if (variants.length < 2) return;
    if (product && product.flickity && product.flickity.slideshow &&
        product.flickity.slideshow.isActive) {
      var controller = createController(scope, product, variants);
      if (controller) {
        controllers.push(controller);
      }
      return; // Ready but unsupported/native-group markup remains untouched.
    }
    // Impulse initializes quick-shop products lazily. Never hide before it does.
    if (attempt < 12 && !pending.has(scope)) {
      pending.set(scope, window.setTimeout(function () {
        pending.delete(scope);
        init(scope, attempt + 1);
      }, 150));
    }
  }

  function boot() {
    document.querySelectorAll(SCOPE).forEach(function (scope) { init(scope, 0); });
  }

  document.addEventListener('variant:change', function (event) {
    var variant = event.detail && event.detail.variant;
    if (!variant) return;
    controllers.forEach(function (state) {
      if (state.scope.isConnected && state.variantsById[String(variant.id)]) {
        apply(state, variant);
      }
    });
  });
  document.addEventListener('shopify:section:unload', function (event) {
    controllers = controllers.filter(function (state) {
      if (event.target !== state.scope && !event.target.contains(state.scope)) return true;
      window.clearTimeout(state.changeTimer);
      state.scope.removeEventListener('variantChange', state.onVariant, true);
      state.scope.removeEventListener('variantImageChange', state.onVariant, true);
      state.scope.removeEventListener('change', state.onChange);
      return false;
    });
  });
  ['shopify:section:load', 'quickview:loaded', 'quickview:open', 'page:loaded'].forEach(function (name) {
    document.addEventListener(name, boot);
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
